/**
 * Static table of all 30 MLB clubs — keyed by the MLB Stats API team_id
 * which the historical-games endpoint accepts as a query param.
 *
 * `code` lowercase matches the keys in `teamColors.ts` so per-team color
 * lookups stay one map jump away. `abbr` is the canonical 2-3 letter
 * display abbreviation. Sorted alphabetically by fullName so the dropdown
 * is scannable.
 */
export interface TeamMeta {
  id: number;
  fullName: string;
  abbr: string;
  code: string;
  league: 'AL' | 'NL';
}

export const MLB_TEAMS: readonly TeamMeta[] = [
  { id: 109, fullName: 'Arizona Diamondbacks', abbr: 'ARI', code: 'ari', league: 'NL' },
  { id: 144, fullName: 'Atlanta Braves', abbr: 'ATL', code: 'atl', league: 'NL' },
  { id: 110, fullName: 'Baltimore Orioles', abbr: 'BAL', code: 'bal', league: 'AL' },
  { id: 111, fullName: 'Boston Red Sox', abbr: 'BOS', code: 'bos', league: 'AL' },
  { id: 145, fullName: 'Chicago White Sox', abbr: 'CWS', code: 'cws', league: 'AL' },
  { id: 112, fullName: 'Chicago Cubs', abbr: 'CHC', code: 'chc', league: 'NL' },
  { id: 113, fullName: 'Cincinnati Reds', abbr: 'CIN', code: 'cin', league: 'NL' },
  { id: 114, fullName: 'Cleveland Guardians', abbr: 'CLE', code: 'cle', league: 'AL' },
  { id: 115, fullName: 'Colorado Rockies', abbr: 'COL', code: 'col', league: 'NL' },
  { id: 116, fullName: 'Detroit Tigers', abbr: 'DET', code: 'det', league: 'AL' },
  { id: 117, fullName: 'Houston Astros', abbr: 'HOU', code: 'hou', league: 'AL' },
  { id: 118, fullName: 'Kansas City Royals', abbr: 'KC', code: 'kc', league: 'AL' },
  { id: 108, fullName: 'Los Angeles Angels', abbr: 'LAA', code: 'laa', league: 'AL' },
  { id: 119, fullName: 'Los Angeles Dodgers', abbr: 'LAD', code: 'lad', league: 'NL' },
  { id: 146, fullName: 'Miami Marlins', abbr: 'MIA', code: 'mia', league: 'NL' },
  { id: 158, fullName: 'Milwaukee Brewers', abbr: 'MIL', code: 'mil', league: 'NL' },
  { id: 142, fullName: 'Minnesota Twins', abbr: 'MIN', code: 'min', league: 'AL' },
  { id: 121, fullName: 'New York Mets', abbr: 'NYM', code: 'nym', league: 'NL' },
  { id: 147, fullName: 'New York Yankees', abbr: 'NYY', code: 'nyy', league: 'AL' },
  { id: 133, fullName: 'Oakland Athletics', abbr: 'OAK', code: 'oak', league: 'AL' },
  { id: 143, fullName: 'Philadelphia Phillies', abbr: 'PHI', code: 'phi', league: 'NL' },
  { id: 134, fullName: 'Pittsburgh Pirates', abbr: 'PIT', code: 'pit', league: 'NL' },
  { id: 135, fullName: 'San Diego Padres', abbr: 'SD', code: 'sd', league: 'NL' },
  { id: 137, fullName: 'San Francisco Giants', abbr: 'SF', code: 'sf', league: 'NL' },
  { id: 136, fullName: 'Seattle Mariners', abbr: 'SEA', code: 'sea', league: 'AL' },
  { id: 138, fullName: 'St. Louis Cardinals', abbr: 'STL', code: 'stl', league: 'NL' },
  { id: 139, fullName: 'Tampa Bay Rays', abbr: 'TB', code: 'tb', league: 'AL' },
  { id: 140, fullName: 'Texas Rangers', abbr: 'TEX', code: 'tex', league: 'AL' },
  { id: 141, fullName: 'Toronto Blue Jays', abbr: 'TOR', code: 'tor', league: 'AL' },
  { id: 120, fullName: 'Washington Nationals', abbr: 'WSH', code: 'wsh', league: 'NL' },
];

export function findTeamById(id: number): TeamMeta | undefined {
  return MLB_TEAMS.find((t) => t.id === id);
}
